const state = () => ({
  DataFrom4: {
    tes_id: "",

    stu_homeid_reg: "",
    stu_village_reg: "",
    stu_soi_reg: "",
    stu_road_reg: "",
    stu_loality_reg: "",
    stu_district_reg: "",
    stu_province_reg: "",
    stu_postcode_reg: "",
    stu_phone_reg: "",

    stu_homeid: "",
    stu_village: "",
    stu_soi: "",
    stu_road: "",
    stu_locality: "",
    stu_district: "",
    stu_province: "",
    stu_postcode: "",
    stu_phone: "",

    select_year: "",
  },

  DataProvince: [],
  DataDistrict: [],
  DataDistrictD: [],
  DataLocality: [],
  DataLocalityD: [],
  SetStep4: [],
});
/* ========== getters ========== */
const getters = {
  _getDataFrom4: (state) => {
    return state.DataFrom4;
  },
  _getDataProvince: (state) => {
    return state.DataProvince;
  },
  _getDataDistrict: (state) => {
    return state.DataDistrict;
  },
  _getDataDistrictD: (state) => {
    return state.DataDistrictD;
  },
  _getDataLocality: (state) => {
    return state.DataLocality;
  },
  _getDataLocalityD: (state) => {
    return state.DataLocalityD;
  },
  _SetStep4: (state) => {
    return state.SetStep4;
  },
};
/* ========== actions ========== */
const actions = {
  async SetStepStatus({ state, rootState }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      const response = await window.Axios.post(
        `${window.api}exec/GetStepStatus4/`,
        state.DataFrom4
      );
      rootState.Main.DataStep4 = response.data;
    } catch (error) {
      console.error(error);
    }
  },
  async SetStep4({ state }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      let data = {
        tes_id: state.DataFrom4.tes_id,
      };
      const response = await window.Axios.post(
        `${window.api}post/GetStep4/`,
        data
      );
      state.SetStep4 = response.data;

      const statStep4 = state.SetStep4;
      const From4 = state.DataFrom4;

      if (state.SetStep4 != "") {
        statStep4.stu_homeid_reg
          ? (From4.stu_homeid_reg = statStep4.stu_homeid_reg.trim())
          : "";
        statStep4.stu_village_reg
          ? (From4.stu_village_reg = statStep4.stu_village_reg.trim())
          : "";
        statStep4.stu_soi_reg
          ? (From4.stu_soi_reg = statStep4.stu_soi_reg.trim())
          : "";
        statStep4.stu_road_reg
          ? (From4.stu_road_reg = statStep4.stu_road_reg.trim())
          : "";
        statStep4.stu_loality_reg
          ? (From4.stu_loality_reg = statStep4.stu_loality_reg.trim())
          : "";
        statStep4.stu_district_reg
          ? (From4.stu_district_reg = statStep4.stu_district_reg.trim())
          : "";
        statStep4.stu_province_reg
          ? (From4.stu_province_reg = statStep4.stu_province_reg.trim())
          : "";
        statStep4.stu_postcode_reg
          ? (From4.stu_postcode_reg = statStep4.stu_postcode_reg.trim())
          : "";
        state.SetStep4.stu_phone_reg
          ? (From4.stu_phone_reg = state.SetStep4.stu_phone_reg.trim())
          : "";
        statStep4.stu_homeid
          ? (From4.stu_homeid = statStep4.stu_homeid.trim())
          : "";
        statStep4.stu_village
          ? (From4.stu_village = statStep4.stu_village.trim())
          : "";
        statStep4.stu_soi ? (From4.stu_soi = statStep4.stu_soi.trim()) : "";
        statStep4.stu_road ? (From4.stu_road = statStep4.stu_road.trim()) : "";
        statStep4.stu_locality
          ? (From4.stu_locality = statStep4.stu_locality.trim())
          : "";
        statStep4.stu_district
          ? (From4.stu_district = statStep4.stu_district.trim())
          : "";
        statStep4.stu_province
          ? (From4.stu_province = statStep4.stu_province.trim())
          : "";
        statStep4.stu_postcode
          ? (From4.stu_postcode = statStep4.stu_postcode.trim())
          : "";
        statStep4.stu_phone
          ? (From4.stu_phone = statStep4.stu_phone.trim())
          : "";
      }
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataProvince({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetProvince/`);
      await commit("GET_DataProvince", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataDistrict({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetDistrict/`,
        state.DataFrom4
      );
      await commit("POST_DataDistrict", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataDistrictD({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetDistrictD/`,
        state.DataFrom4
      );
      await commit("POST_DataDistrictD", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataDistrictRegistration({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetDistrictRegistration/`,
        state.DataFrom4
      );
      await commit("POST_DataDistrictD", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataLocality({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetLocality/`,
        state.DataFrom4
      );
      await commit("POST_DataLocality", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataLocalityD({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetLocalityD/`,
        state.DataFrom4
      );
      await commit("POST_DataLocalityD", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataLocalityRegistration({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetLocalityRegistration/`,
        state.DataFrom4
      );
      await commit("POST_DataLocalityD", response.data);
    } catch (error) {
      console.error(error);
    }
  },
};

/* ========== mutations ========== */
const mutations = {
  GET_DataProvince(state, payload) {
    state.DataProvince = payload;
  },
  POST_DataDistrict(state, payload) {
    state.DataDistrict = payload;
  },
  POST_DataDistrictD(state, payload) {
    state.DataDistrictD = payload;
  },
  POST_DataLocality(state, payload) {
    state.DataLocality = payload;
  },
  POST_DataLocalityD(state, payload) {
    state.DataLocalityD = payload;
  },
};

/* ========== Export ========== */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
